const CACHE_TTL = 5 * 60 * 1000;
const MAX_CACHE_ENTRIES = 50;

const responseCache = new Map();
const pendingRequests = new Map();
let cacheGeneration = 0;

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function stableSerialize(value) {
  if (Array.isArray(value)) {
    return `[${value.map(stableSerialize).join(',')}]`;
  }
  if (value && typeof value === 'object') {
    return `{${Object.keys(value)
      .filter((key) => value[key] !== undefined)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${stableSerialize(value[key])}`)
      .join(',')}}`;
  }
  return JSON.stringify(value);
}

function pruneCache() {
  const now = Date.now();
  responseCache.forEach((entry, key) => {
    if (entry.expiresAt <= now) responseCache.delete(key);
  });

  while (responseCache.size >= MAX_CACHE_ENTRIES) {
    responseCache.delete(responseCache.keys().next().value);
  }
}

export function clearPhysicianListCache() {
  cacheGeneration += 1;
  responseCache.clear();
  pendingRequests.clear();
}

export function withPhysicianListCache(params, sortOrder, requestFn) {
  const cacheKey = stableSerialize({params, sortOrder: sortOrder || ''});
  const requestGeneration = cacheGeneration;
  const cached = responseCache.get(cacheKey);

  if (cached && cached.expiresAt > Date.now()) {
    responseCache.delete(cacheKey);
    responseCache.set(cacheKey, cached);
    return Promise.resolve(clone(cached.value));
  }
  if (cached) responseCache.delete(cacheKey);

  const pending = pendingRequests.get(cacheKey);
  if (pending) return pending.then(clone);

  const requestPromise = requestFn().then(
    (response) => {
      if (pendingRequests.get(cacheKey) === requestPromise) {
        pendingRequests.delete(cacheKey);
      }
      if (requestGeneration === cacheGeneration && response?.isSuccess !== false) {
        pruneCache();
        responseCache.set(cacheKey, {
          expiresAt: Date.now() + CACHE_TTL,
          value: clone(response),
        });
      }
      return response;
    },
    (error) => {
      if (pendingRequests.get(cacheKey) === requestPromise) {
        pendingRequests.delete(cacheKey);
      }
      throw error;
    },
  );

  pendingRequests.set(cacheKey, requestPromise);
  return requestPromise.then(clone);
}
